




















import Vue from 'vue';
import {Component, Watch, Prop} from 'vue-property-decorator';
import dayjs from 'dayjs';

@Component
export default class FormItem extends Vue {
  @Prop({default: ''})  value!: string;

  @Prop({required: true}) fieldName!: string;
  @Prop() placeholder?: string;
  @Prop() type?: string;

  onValueChanged(value: string) {
    this.$emit('update:value', value);
  }
  x(isoString: string){
    return dayjs(isoString).format('YYYY-MM-DD')
  }
}
